import CampanaNotificaciones from "./CampanaNotificaciones";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState } from "react";
import { subirDatos, eliminarDato } from "./syncSupabase";

const estadosOT2 = { pendiente: { label: "⏳ Pendiente", color: "#f59e0b" }, en_proceso: { label: "🔵 En proceso", color: "#3b82f6" }, revision: { label: "🔍 En revisión", color: "#7B5BF2" }, aprobado: { label: "✅ Aprobado", color: "#22c55e" }, rechazado: { label: "🔴 Rechazado", color: "#e63946" } };
const tiposDocTecnico = ["Especificación técnica", "Ficha de producto", "Muestra patrón", "Plano de corte", "Esquema de armado", "Layout de impresión", "Otro"];

function generarCodOT2(lista) { return `OFT-${new Date().getFullYear()}-${String(lista.length + 1).padStart(4, "0")}`; }
function fechaHoy() { return new Date().toISOString().slice(0, 10); }

export default function OficinaTecnica({ onVolver, oscuro, usuario }) {
  const [registros, setRegistros] = useState(() => {
    try { return JSON.parse(localStorage.getItem('alqos_oficina_tecnica') || '[]'); } catch { return []; }
  });
  const [vista, setVista] = useState("listado");
  const [form, setForm] = useState({ estado: "pendiente", tipo: "Especificación técnica", fecha: fechaHoy() });
  const [detalle, setDetalle] = useState(null);
  const [confirmEliminar, setConfirmEliminar] = useState(null);
  const [busqueda, setBusqueda] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("todos");

  const bg = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde = oscuro ? "#1e3a8a" : "#eee";
  const navBg = oscuro ? "#060f30" : "#09184D";
  const subtexto = oscuro ? "#9aabd4" : "#808085";
  const esAdmin = usuario?.rol === "Administrador";

  const inp = { width: "100%", padding: "8px 12px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "13px", boxSizing: "border-box", marginTop: "4px", background: cardBg, color: texto, fontFamily: "sans-serif" };
  const lbl = { fontSize: "12px", color: oscuro ? "#9aabd4" : "#555", fontWeight: "600", display: "block", marginTop: "12px" };
  const card = { background: cardBg, borderRadius: "12px", padding: "1.5rem", border: `1px solid ${borde}`, marginBottom: "12px" };

  const guardar = () => {
    const nuevo = { ...form, id: Date.now(), codigo: generarCodOT2(registros), fechaCreacion: new Date().toISOString(), creadoPor: usuario?.nombre || "Sistema", rolCreador: usuario?.rol || "" };
    const nuevos = [...registros, nuevo];
    setRegistros(nuevos);
    localStorage.setItem('alqos_oficina_tecnica', JSON.stringify(nuevos)); subirDatos('alqos_oficina_tecnica');
    setForm({ estado: "pendiente", tipo: "Especificación técnica", fecha: fechaHoy() });
    setVista("listado");
  };

  const eliminar = async (id) => {
    const nuevos = registros.filter(r => r.id !== id);
    setRegistros(nuevos);
    localStorage.setItem('alqos_oficina_tecnica', JSON.stringify(nuevos));
    await eliminarDato('alqos_oficina_tecnica', id);
    setConfirmEliminar(null); setDetalle(null); setVista("listado");
  };

  const cambiarEstado = (id, nuevoEstado) => {
    const actualizados = registros.map(r => r.id === id ? { ...r, estado: nuevoEstado } : r);
    setRegistros(actualizados);
    localStorage.setItem('alqos_oficina_tecnica', JSON.stringify(actualizados)); subirDatos('alqos_oficina_tecnica');
    if (detalle?.id === id) setDetalle(prev => ({ ...prev, estado: nuevoEstado }));
  };

  const registrosFiltrados = registros.filter(r => {
    const matchEstado = filtroEstado === "todos" || r.estado === filtroEstado;
    const matchBusqueda = !busqueda || r.cliente?.toLowerCase().includes(busqueda.toLowerCase()) || r.codigo?.toLowerCase().includes(busqueda.toLowerCase()) || r.producto?.toLowerCase().includes(busqueda.toLowerCase());
    return matchEstado && matchBusqueda;
  });

  const Header = ({ titulo, onBack, extra }) => (
    <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100, marginBottom: "1.5rem" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <button onClick={onBack} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Volver</button>
        <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>{titulo}</span>
      </div>
      {extra}
    </div>
  );

  if (confirmEliminar) return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: cardBg, borderRadius: "16px", padding: "2rem", maxWidth: "360px", width: "90%", border: `1px solid ${borde}`, textAlign: "center" }}>
        <p style={{ fontSize: "32px", marginBottom: "1rem" }}>📐</p>
        <p style={{ fontSize: "15px", fontWeight: "600", color: texto, marginBottom: ".5rem" }}>¿Eliminar este registro?</p>
        <p style={{ fontSize: "13px", color: subtexto, marginBottom: "1.5rem" }}>Esta acción no se puede deshacer.</p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button onClick={() => setConfirmEliminar(null)} style={{ padding: "10px 20px", background: "none", border: `1px solid ${borde}`, borderRadius: "10px", cursor: "pointer", color: texto, fontSize: "13px" }}>Cancelar</button>
          <button onClick={() => eliminar(confirmEliminar)} style={{ padding: "10px 20px", background: "#e63946", border: "none", borderRadius: "10px", cursor: "pointer", color: "white", fontSize: "13px", fontWeight: "600" }}>Eliminar</button>
        </div>
      </div>
    </div>
  );

  if (vista === "detalle" && detalle) return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header titulo={detalle.codigo}
        onBack={() => { setDetalle(null); setVista("listado"); }}
        extra={esAdmin && <button onClick={() => setConfirmEliminar(detalle.id)} style={{ background: "rgba(230,57,70,.2)", border: "1px solid rgba(230,57,70,.4)", color: "#e63946", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "12px" }}>🗑 Eliminar</button>}
      />
      <div style={{ padding: "0 2rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
        <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#F0EEFF", border: `1px solid ${oscuro ? "#7B5BF2" : "#d4c8ff"}` }}>
          <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#7B5BF2", marginBottom: "10px" }}>Datos técnicos</h3>
          {[["Código", detalle.codigo], ["Tipo", detalle.tipo], ["Cliente", detalle.cliente], ["Producto", detalle.producto], ["Versión", detalle.version], ["Fecha", detalle.fecha], ["Responsable técnico", detalle.responsable], ["Aprobado por", detalle.aprobadoPor], ["Creado por", `${detalle.creadoPor} — ${detalle.rolCreador}`]].map(([k, v]) => v && (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", padding: "4px 0", borderBottom: `0.5px solid ${borde}` }}>
              <span style={{ color: subtexto }}>{k}</span>
              <span style={{ color: texto, fontWeight: "500", maxWidth: "60%", textAlign: "right" }}>{v}</span>
            </div>
          ))}
        </div>
        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", color: "#7B5BF2", marginBottom: "12px" }}>Estado</h3>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {Object.entries(estadosOT2).map(([val, { label, color }]) => (
              <button key={val} onClick={() => esAdmin && cambiarEstado(detalle.id, val)}
                style={{ padding: "7px 12px", borderRadius: "10px", fontSize: "12px", cursor: esAdmin ? "pointer" : "default", fontWeight: "600", border: detalle.estado === val ? `2px solid ${color}` : `1px solid ${borde}`, background: detalle.estado === val ? `${color}22` : cardBg, color: detalle.estado === val ? color : subtexto }}>
                {label}
              </button>
            ))}
          </div>
        </div>
        {[["Descripción técnica", detalle.descripcion], ["Especificaciones de material", detalle.especMaterial], ["Medidas y tolerancias", detalle.medidas], ["Colores y acabados", detalle.colores], ["Observaciones", detalle.observaciones]].map(([label, val]) => val && (
          <div key={label} style={card}>
            <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#09184D", marginBottom: "8px" }}>{label}</h3>
            <p style={{ fontSize: "13px", color: texto, lineHeight: "1.6", margin: 0 }}>{val}</p>
          </div>
        ))}
      </div>
    </div>
  );

  if (vista === "nueva") return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header titulo="Nuevo Documento Técnico" onBack={() => setVista("listado")} />
      <div style={{ padding: "0 2rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
        <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#F0EEFF", border: `1px solid ${oscuro ? "#7B5BF2" : "#d4c8ff"}` }}>
          <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#7B5BF2", marginBottom: "4px" }}>Trazabilidad automática</h3>
          <p style={{ fontSize: "12px", color: subtexto, margin: 0 }}>Creado por: <strong style={{ color: texto }}>{usuario?.nombre}</strong> — {usuario?.rol}</p>
        </div>
        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px", color: "#09184D" }}>Datos del documento</h3>
          <span style={lbl}>Tipo de documento</span>
          <select onChange={e => setForm(f => ({ ...f, tipo: e.target.value }))} style={inp} defaultValue="Especificación técnica">
            {tiposDocTecnico.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
          <span style={lbl}>Estado inicial</span>
          <div style={{ display: "flex", gap: "8px", marginTop: "6px", flexWrap: "wrap" }}>
            {Object.entries(estadosOT2).map(([val, { label, color }]) => (
              <button key={val} onClick={() => setForm(f => ({ ...f, estado: val }))}
                style={{ padding: "7px 12px", borderRadius: "10px", fontSize: "12px", cursor: "pointer", fontWeight: "600", border: form.estado === val ? `2px solid ${color}` : `1px solid ${borde}`, background: form.estado === val ? `${color}22` : cardBg, color: form.estado === val ? color : texto }}>
                {label}
              </button>
            ))}
          </div>
          {[{ key: "cliente", label: "Cliente" }, { key: "producto", label: "Producto / Código" }, { key: "version", label: "Versión (ej: 1.0)" }, { key: "fecha", label: "Fecha", type: "date" }, { key: "responsable", label: "Responsable técnico" }, { key: "aprobadoPor", label: "Aprobado por" }, { key: "descripcion", label: "Descripción técnica", multiline: true }, { key: "especMaterial", label: "Especificaciones de material", multiline: true }, { key: "medidas", label: "Medidas y tolerancias", multiline: true }, { key: "colores", label: "Colores y acabados" }, { key: "observaciones", label: "Observaciones", multiline: true }].map(({ key, label, type, multiline }) => (
            <div key={key}>
              <span style={lbl}>{label}</span>
              {multiline ? <textarea rows={3} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={{ ...inp, resize: "none" }} /> : <input type={type || "text"} defaultValue={key === "fecha" ? fechaHoy() : ""} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={inp} />}
            </div>
          ))}
        </div>
        <button onClick={guardar} style={{ width: "100%", padding: "14px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "10px", fontSize: "15px", fontWeight: "600", cursor: "pointer", marginTop: "1rem" }}>
          Guardar Documento Técnico
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button onClick={onVolver} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Menú</button>
          <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>Oficina Técnica</span>
        </div>
        <CampanaNotificaciones oscuro={oscuro} modulo="OficinaTecnica" />
          {esAdmin && <button onClick={() => setVista("nueva")} style={{ padding: "6px 14px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>+ Nuevo</button>}
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="oficina_tecnica" oscuro={oscuro} />}
      </div>
      <div style={{ padding: "1rem 1.5rem" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: "10px", marginBottom: "1.5rem" }}>
          {[["Total", registros.length, "#7B5BF2"], ["Aprobados", registros.filter(r => r.estado === "aprobado").length, "#22c55e"], ["En proceso", registros.filter(r => r.estado === "en_proceso").length, "#3b82f6"], ["Pendientes", registros.filter(r => r.estado === "pendiente").length, "#f59e0b"]].map(([lab, val, col]) => (
            <div key={lab} style={{ background: cardBg, borderRadius: "12px", padding: "1rem", border: `1px solid ${borde}`, textAlign: "center" }}>
              <p style={{ fontSize: "22px", fontWeight: "700", color: col, margin: 0 }}>{val}</p>
              <p style={{ fontSize: "11px", color: subtexto, margin: "4px 0 0" }}>{lab}</p>
            </div>
          ))}
        </div>
        <input placeholder="🔍 Buscar por cliente, producto o código..." value={busqueda} onChange={e => setBusqueda(e.target.value)} style={{ ...inp, marginBottom: "1rem", marginTop: 0 }} />
        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "1rem" }}>
          <button onClick={() => setFiltroEstado("todos")} style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtroEstado === "todos" ? "2px solid #7B5BF2" : `1px solid ${borde}`, background: filtroEstado === "todos" ? "rgba(123,91,242,.1)" : cardBg, color: filtroEstado === "todos" ? "#7B5BF2" : subtexto }}>Todos</button>
          {Object.entries(estadosOT2).map(([val, { label, color }]) => (
            <button key={val} onClick={() => setFiltroEstado(val)} style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtroEstado === val ? `2px solid ${color}` : `1px solid ${borde}`, background: filtroEstado === val ? `${color}22` : cardBg, color: filtroEstado === val ? color : subtexto }}>{label}</button>
          ))}
        </div>
        {registrosFiltrados.length === 0
          ? <div style={{ textAlign: "center", padding: "4rem" }}><p style={{ fontSize: "40px" }}>📐</p><p style={{ fontSize: "15px", color: texto }}>No hay documentos técnicos registrados</p></div>
          : registrosFiltrados.map(r => (
              <div key={r.id} onClick={() => { setDetalle(r); setVista("detalle"); }}
                style={{ background: cardBg, borderRadius: "12px", padding: "1.2rem 1.5rem", border: `1px solid ${borde}`, marginBottom: "10px", cursor: "pointer" }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 16px rgba(123,91,242,0.15)"}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div>
                    <span style={{ fontWeight: "700", color: "#7B5BF2", fontSize: "13px" }}>{r.codigo}</span>
                    <span style={{ marginLeft: "10px", fontSize: "13px", color: texto, fontWeight: "600" }}>{r.cliente || "Sin cliente"}</span>
                    <p style={{ fontSize: "12px", color: subtexto, marginTop: "4px" }}>{r.tipo} · {r.producto || "Sin producto"} · v{r.version || "1.0"}</p>
                  </div>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: estadosOT2[r.estado]?.color }}>{estadosOT2[r.estado]?.label}</span>
                </div>
                <div style={{ marginTop: "6px", fontSize: "11px", color: oscuro ? "#7B5BF2" : "#9b8cc4" }}>Responsable: {r.responsable || "—"} · {r.fecha}</div>
              </div>
            ))
        }
      </div>
    </div>
  );
}